import { render, staticRenderFns } from "./Schools.vue?vue&type=template&id=1e5cd280"
import script from "./Schools.vue?vue&type=script&lang=js"
export * from "./Schools.vue?vue&type=script&lang=js"
import style0 from "./Schools.vue?vue&type=style&index=0&id=1e5cd280&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports